<template>
  <div class="ts-space-y-1">
    <label class="required">{{ placeholder }}</label>
    <input 
			v-model="model.password" 
			type="password" 
			class="form-control"
			:class="{ 'is-invalid': errors.has('password') }" 
		/>
    <div class="invalid-feedback" v-if="errors.has('password')">{{ errors.first('password') }}</div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'confirmPassword',
  props: [
    'value',
    'validate',
    'placeholder',
  ],
  data() {
    return {
      model: {},
      errors: new Errors()
    }
  },
  created() {
    this.model = this.value
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
